import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.png'

import { Web3Button } from '@web3modal/react'
import { useWeb3Modal } from '@web3modal/react'
import { useAccount, useContract } from 'wagmi'

import { useWeb3ModalTheme } from '@web3modal/react'


export default function Header() {
  const { open, close } = useWeb3Modal()
  const { theme, setTheme } = useWeb3ModalTheme()

  setTheme({
    themeMode: 'dark',
    themeVariables: {
      '--w3m-font-family': 'Roboto, sans-serif',
      '--w3m-accent-color': '#F5841F',
      '--w3m-background-color':'#F5841F'
    }
  })

  return (
    <header className="header">
    <div className="header__bottom">
      <div className="container">
        <nav className="navbar navbar-expand-xl p-0 align-items-center">
          <a className="site-logo site-title" href="index.html">
            <img src={Logo} alt="site-logo" />
          </a>
          <ul className="account-menu mobile-acc-menu">
            <li className="icon">
              {/* <a className='anchar' href="login.html">
                <i className="las la-user" />
              </a> */}
              <Web3Button />
            </li>
          </ul>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="menu-toggle" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav main-menu m-auto">
              <li>
                {" "}
                <a className='anchar' href="index.html">Home</a>
              </li>
              <li>
                {" "}
                <a className='anchar' href="about.html">About Us</a>
              </li>
              <li>
                {" "}
                <a className='anchar' href="plan.html">Plan</a>
              </li>
              <li>
                <a className='anchar' href="dashboard.html">Dashboard</a>
              </li>
              <li className="menu_has_children">
                <a className='anchar' href="#0">Blog</a>
                <ul className="sub-menu">
                  <li>
                    <a className='anchar' href="blog.html">Blog Posts</a>
                  </li>
                  <li>
                    <a className='anchar' href="blog-details.html">Blog Details</a>
                  </li>
                </ul>
              </li>
         
              <li>
                <a className='anchar' href="contact.html">Contact</a>
              </li>
            </ul>
            <div className="nav-right">
            {/* <ul className="account-menu ml-3">
                <li className="icon">
                  <a style={{color:'white', textDecoration:'none'}}>
                    Login
                  </a>
                </li>
              </ul> */}
              <ul className="account-menu ml-3">
             
                <li className="icon">
                  {/* <a className='anchar' href="login.html">
                    <i className="las la-user" />
                  </a> */}
                   <Web3Button />
                </li>
              </ul>
          
              {/* <select className="select d-inline-block w-auto ml-xl-3">
                <option>Eng</option>
                <option>Ban</option>
                <option>Hin</option>
              </select> */}
            </div>
          </div>
        </nav>
      </div>
    </div>
    {/* header__bottom end */}
  </header>
  
  );
}